import { render, staticRenderFns } from "./DtDetailTwo.vue?vue&type=template&id=2b481bd5&scoped=true"
import script from "./DtDetailTwo.vue?vue&type=script&lang=js"
export * from "./DtDetailTwo.vue?vue&type=script&lang=js"
import style0 from "./DtDetailTwo.vue?vue&type=style&index=0&id=2b481bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b481bd5",
  null
  
)

export default component.exports